export const WEBSITE_URL = {
    BASE_URL: 'http://localhost:3000',
    FORGOT_PASSWORD_EXT: '/forgotpassword',
    SIGNUP_EXT: '/signup',
    SETTINGS_EXT: '/settings'
} 

export const EXTENSION_URL = {
    DOWNLOAD_URL: 'https://github.com/ShauryaS/QuickFiller-Extension-Unpacked',
} 